export const theme = {
  light: {
    bg: "#f7f8fa",
    text: "#fff",
    secondaryText: "#555",
    card: "#0059A3",
    border: "#e5e7eb",
    accent: "#6366F1",
  },

  dark: {
    bg: "#0a0a0a",
    text: "#111",
    secondaryText: "#aaa",
    card: "rgba(237, 243, 245, 0.95)",
    border: "rgba(255,255,255,0.1)",
    accent: "#6366F1",
  },
};
